/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListMembersStatusNot = typeof ListMembersStatusNot[keyof typeof ListMembersStatusNot] | null;


export const ListMembersStatusNot = {
  active: 'active',
  inactive: 'inactive',
} as const;
